<template>
  <router-view />
</template>

<script>
import { onMounted, onUnmounted } from "vue"

let currentVersion = null
let versionChecker = null

const loadCurrentVersion = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`)
    const data = await res.json()

    currentVersion = data.version
  } catch (error) {
    console.error(error)
  }
}

const checkForUpdate = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`)
    const data = await res.json()

    if (currentVersion && currentVersion !== data.version) {
      window.location.reload()
    }
  } catch (error) {
    console.error(error)
  }
}

onMounted(async () => {
  await loadCurrentVersion()

  versionChecker = setInterval(checkForUpdate, 60000)
})

onUnmounted(() => {
  clearInterval(versionChecker)
})

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap');

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #64cf69;
  margin-top: 0px;
}
</style>
